import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { L10n } from '@skylab-angular-shared/core';
import { TooltipDirective, IconComponent } from '@skylab-angular-shared/ui';
import { L10nBase } from '@skylab-shared/core';

@Component({
	selector: 'skl-document-list-note-cell',
	template: `
        @if (note()) {
            <div
                class="cell-icon-wrapper">
                <skl-icon
                    [tooltip]="tooltip()"
                    name="note"
                    size="16px">
                </skl-icon>
            </div>
        }
	`,
    styles: `
        [name="note"] {
            --icon-color: light-dark(hsl(from var(--warning-color) h s 63%), hsl(from var(--warning-color) h s 30%));
        }
    `,
	imports: [TooltipDirective, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentListNoteCellComponent {
    #l10n = inject(L10n) as L10nBase;

	public readonly note = input.required<string>();
    public readonly tooltip = computed(() => `${this.#l10n.instant('scenes.shared.control.document-list-note-cell.title')}: ${this.note()}`)
}
